export interface ComplianceTypeDefinition {
  key: string;
  label: string;
  jurisdictions: string[];
  appliesToAll: boolean;
  evidence: string;
  risk: 'critical' | 'high' | 'medium' | 'low';
  requiresNextDueDate?: boolean;
  jurisdictionNotes?: string;
  eligibilityNotes?: string;
}

export const COMPLIANCE_TYPE_DEFINITIONS: ComplianceTypeDefinition[] = [
  {
    key: 'water_potability',
    label: 'Potabilidad del Agua',
    jurisdictions: [],
    appliesToAll: true,
    evidence: 'Protocolo de Análisis (Informe de Laboratorio)',
    risk: 'critical',
  },
  {
    key: 'tank_cleaning',
    label: 'Limpieza de Tanques',
    jurisdictions: ['CABA', 'Rosario', 'Córdoba'],
    appliesToAll: false,
    evidence: 'Certificado de Limpieza + Análisis',
    risk: 'high',
  },
  {
    key: 'pest_control_caba_rosario',
    label: 'Control de Plagas (CABA / Rosario)',
    jurisdictions: ['CABA', 'Rosario'],
    appliesToAll: false,
    evidence: 'Certificado QR / Sticker',
    risk: 'critical',
  },
  {
    key: 'pest_control_cba',
    label: 'Control de Plagas (Córdoba)',
    jurisdictions: ['Córdoba'],
    appliesToAll: false,
    evidence: 'Certificado Oficial',
    risk: 'critical',
  },
  {
    key: 'hood_cleaning',
    label: 'Limpieza de Campanas',
    jurisdictions: ['CABA'],
    appliesToAll: false,
    evidence: 'Certificado ELCCA',
    risk: 'high',
  },
  {
    key: 'fire_extinguishers',
    label: 'Extintores de Incendio',
    jurisdictions: [],
    appliesToAll: true,
    evidence: 'Tarjeta (Tag) y Marbete (Anillo)',
    risk: 'critical',
    jurisdictionNotes: 'Federal (Ley 19.587)',
  },
  {
    key: 'fire_extinguisher_review',
    label: 'Revisión de Extintores',
    jurisdictions: [],
    appliesToAll: true,
    evidence: 'Registro Interno / Etiqueta de Servicio',
    risk: 'medium',
    jurisdictionNotes: 'Federal',
  },
  {
    key: 'habilitacion_establecimiento',
    label: 'Habilitación de Establecimiento',
    jurisdictions: [],
    appliesToAll: true,
    evidence: 'PDF con habilitación / Código QR',
    risk: 'critical',
  },
  {
    key: 'used_oil',
    label: 'Aceite Usado (AVU)',
    jurisdictions: ['PBA', 'CABA', 'Mendoza'],
    appliesToAll: false,
    evidence: 'Manifiesto / Certificado de Retiro',
    risk: 'medium',
    requiresNextDueDate: true,
  },
  {
    key: 'waste_mgmt_caba',
    label: 'Gestión de Residuos (CABA)',
    jurisdictions: ['CABA'],
    appliesToAll: false,
    evidence: 'Contrato y Facturas Mensuales',
    risk: 'medium',
    eligibilityNotes: '>40kg/día',
  },
  {
    key: 'waste_mgmt_cba',
    label: 'Gestión de Residuos (Córdoba)',
    jurisdictions: ['Córdoba'],
    appliesToAll: false,
    evidence: 'Contrato y Facturas Mensuales',
    risk: 'medium',
    eligibilityNotes: '>200kg/mes',
  },
  {
    key: 'food_handlers',
    label: 'Manipuladores de Alimentos',
    jurisdictions: [],
    appliesToAll: true,
    evidence: 'Carnet de Manipulador',
    risk: 'high',
    jurisdictionNotes: 'Nacional (CAA)',
  },
  {
    key: 'environmental_clearance',
    label: 'Aptitud Ambiental',
    jurisdictions: ['CABA'],
    appliesToAll: false,
    evidence: 'Certificado Aptitud Ambiental',
    risk: 'low',
    jurisdictionNotes: 'Ley 123',
  },
  {
    key: 'reba_license',
    label: 'ReBA (Alcohol)',
    jurisdictions: ['PBA'],
    appliesToAll: false,
    evidence: 'Licencia ReBA',
    risk: 'high',
  },
  {
    key: 'fire_certificate',
    label: 'Certificado de Bomberos',
    jurisdictions: ['Santa Fe', 'Mendoza'],
    appliesToAll: false,
    evidence: 'Certificado de Bomberos',
    risk: 'high',
  },
  {
    key: 'grease_trap',
    label: 'Trampa de grasa',
    jurisdictions: ['Municipal'],
    appliesToAll: false,
    evidence: 'Contrato de limpieza: inspección visual',
    risk: 'high',
    requiresNextDueDate: true,
  },
];

export const COMPLIANCE_TYPE_OPTIONS = COMPLIANCE_TYPE_DEFINITIONS.map(
  (definition) => ({
    value: definition.key,
    label: definition.label,
  }),
);

export const COMPLIANCE_JURISDICTION_OPTIONS = Array.from(
  new Set(
    COMPLIANCE_TYPE_DEFINITIONS.flatMap(
      (definition) => definition.jurisdictions,
    ),
  ),
).sort();

export const EVENT_BASED_TYPES = new Set(
  COMPLIANCE_TYPE_DEFINITIONS.filter(
    (definition) => definition.requiresNextDueDate,
  ).map((definition) => definition.key),
);

export const getComplianceTypeDefinition = (typeKey: string) =>
  COMPLIANCE_TYPE_DEFINITIONS.find(
    (definition) => definition.key === typeKey,
  ) ?? null;
